import { Fragment, useMemo } from 'react';
import { getIn, useFormikContext } from 'formik';

import * as Yup from 'yup'

import { FormikFileUpload, FormikNotesArea } from "../../../../../components/widgets"
import { IWebFileAttachment } from '../../../../core/applications';

export interface IDLMPhasA_4_1  {
  verdict: string
  workflow: string
  siteDetails : Array<any>
  note: string
  noteAttachments: Array<IWebFileAttachment>    
}

export const initDLMPhasA_4_1Values = {
  verdict: '', 
  workflow: '',
  siteDetails: [
    {
      projectName: '',
      clientRefNo: '',
      prototypeTestReport: 0,
      trainingRecord: 0,
      methodOfStatement: 0,            
      productConstructionDrawing: 0,            
      sitePlanDrawing: 0,            
      siteChecklist: 0,            
      setscoROI: 0,            
      prototypeTestReportAttachmentName: 0,
      trainingRecordAttachmentName: 0,
      methodOfStatementAttachmentName: 0,
      productConstructionDrawingAttachmentName: 0,
      sitePlanDrawingAttachmentName: 0,
      siteChecklistAttachmentName: 0,
      setscoROIAttachmentName: 0,       
    }
  ],
  note: '',
  noteAttachments: [],  
}

export const DLMPhasA_4_1Schema: any = Yup.object({
  verdict: Yup.string().trim(),    
  workflow: Yup.string().trim(),    
  siteDetails: Yup.array().required().of(
    Yup.object().shape({         
      projectName: Yup.string().trim(), 
      clientRefNo: Yup.string().trim(),   
      prototypeTestReport: Yup.number().integer(),
      trainingRecord: Yup.number().integer(),
      methodOfStatement: Yup.number().integer(),            
      productConstructionDrawing: Yup.number().integer(),            
      sitePlanDrawing: Yup.number().integer(),            
      siteChecklist: Yup.number().integer(),            
      setscoROI: Yup.number().integer(),            
      prototypeTestReportAttachmentName: Yup.string().trim(),
      trainingRecordAttachmentName: Yup.string().trim(),
      methodOfStatementAttachmentName: Yup.string().trim(),
      productConstructionDrawingAttachmentName: Yup.string().trim(),
      sitePlanDrawingAttachmentName: Yup.string().trim(),
      siteChecklistAttachmentName: Yup.string().trim(),
      setscoROIAttachmentName: Yup.string().trim(),        
    })
  ),
  note: Yup.string().trim().label('Note').required(),    
  noteAttachments: Yup.array(),    
});

export const DLMSubmitDocumentsForm = () => {

  const { values } = useFormikContext();
  const { siteDetails } = useMemo(() => {
    if (! (values)) return { siteDetails: []};
    const siteDetails = getIn(values, 'siteDetails');
    return { siteDetails };
  }, [values]);

  return (
  <>
  { (siteDetails && siteDetails.length > 0) && 
  <>
  <h4>Supporting Documents</h4>
  {siteDetails.map( (site: any, index: number) => (    
  <Fragment key={`site${index}${site.clientRefNo}`}>
    <h4 className="mt-4">{`Project Name : ${site.clientRefNo ? site.clientRefNo + ' - ' : ''}${site.projectName}`}</h4>            
    <div className="row mb-4">
      <FormikFileUpload size="6 col-md-4" label="Prototype Test Report" name={`siteDetails.${index}.prototypeTestReport`} acceptFiles="ApplicantFileFormats" />
      <FormikFileUpload size="6 col-md-4" label="Training Record" name={`siteDetails.${index}.trainingRecord`} acceptFiles="ApplicantFileFormats" />
      <FormikFileUpload size="6 col-md-4" label="Method of Statment" name={`siteDetails.${index}.methodOfStatement`} acceptFiles="ApplicantFileFormats" />
      <FormikFileUpload size="6 col-md-4" label="Product Construction DWG" name={`siteDetails.${index}.productConstructionDrawing`} acceptFiles="ApplicantFileFormats" />
      <FormikFileUpload size="6 col-md-4" label="Site Plan/Site DWG" name={`siteDetails.${index}.sitePlanDrawing`} acceptFiles="ApplicantFileFormats" />
      <FormikFileUpload size="6 col-md-4" label="Site Checklist" name={`siteDetails.${index}.siteChecklist`} acceptFiles="ApplicantFileFormats" />
      <FormikFileUpload size="6 col-md-4" label="Setsco ROI" name={`siteDetails.${index}.setscoROI`} acceptFiles="ApplicantFileFormats"  />
    </div>
    <div className='separator border-gray-200 mb-2'></div>        
  </Fragment> 
  ))}
  </>
  }

  <FormikNotesArea required />    
  </>
  )
}